var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCupDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5703 0.304687C11.4922 0.124999 11.3125 -2.38419e-07 11.1094 -2.38419e-07H1.10938C0.90625 -2.38419e-07 0.726563 0.124999 0.648438 0.304687C0.570312 0.492187 0.609375 0.710937 0.757813 0.851562L4.60938 4.70312V8.5C4.60938 8.63281 4.66406 8.75781 4.75781 8.85156L6.75781 10.8516C6.85156 10.9531 6.97656 11 7.10938 11C7.17188 11 7.24219 10.9844 7.30469 10.9609C7.48438 10.8828 7.60938 10.7031 7.60938 10.5V4.70312L11.4609 0.851562C11.6094 0.710937 11.6484 0.492187 11.5703 0.304687Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupDark);
export default __webpack_public_path__ + "static/media/cup-dark.047ac45c4f858ab6763ed6a928351c0a.svg";
export { ForwardRef as ReactComponent };